import React, {
  createContext, useContext, useMemo, useState,
} from 'react'
import { NctsError } from '../../../../shared/ncts/types'

type NctsErrorState = {
  errors: NctsError[]
}

type NctsErrorContextValue = {
  state: NctsErrorState
  setNctsErrors: (errors: NctsError[]) => void
  clearAll: () => void
}

const NctsErrorContext = createContext<NctsErrorContextValue | null>(null)

export function NctsErrorProvider({ children } : Readonly<{ children: React.ReactNode }>) {
  const [nctsErrors, setNctsErrors] = useState<NctsError[]>([])

  const value = useMemo<NctsErrorContextValue>(
    () => ({
      state: { errors: nctsErrors },
      setNctsErrors,
      clearAll: () => {
        setNctsErrors([])
      },
    }),
    [nctsErrors],
  )

  return (
    <NctsErrorContext.Provider value={value}>
      {children}
    </NctsErrorContext.Provider>
  )
}

export function useNctsErrors() {
  const ctx = useContext(NctsErrorContext)
  if (!ctx) throw new Error('useNctsErrors must be used inside <NctsErrorProvider>')
  return ctx
}
